<!--  -->
<template>
  <div class="wrap">
    <top-header></top-header>
    <left-menu></left-menu>
    <div class="rightcontent" :class='{hideSidebars:isCollapse}'>
      <!-- <page-tab></page-tab> -->
      <!-- <bread-crumb></bread-crumb> -->
      <div class="contents">
          <bread-crumb></bread-crumb>
      <el-main>
      <keep-alive :include="keepAlive">
        <router-view />
      </keep-alive>
      </el-main>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftMenu from "../components/leftMenu";
import pageTab from "../components/pageTab";
import breadCrumb from "../components/breadcrum";
import topHeader from "../components/topHeader";
import { mapState, mapMutations } from "vuex";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { leftMenu, pageTab, breadCrumb, topHeader },
  data() {
    //这里存放数据
    return {};
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getMenu();
  },
  computed: {
    ...mapState(["leftMenu", "leftMenuActiveName", "keepPageTabs","isCollapse","keepAlive"])
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        let routeParams = to.params;
        let meta = to.meta || {};
        let currentRouteName = to.name; // 当前路由 name
        let originRouteName = currentRouteName; // 顶级菜单路由名称
        //更新leftMenuActiveName
        if (meta.activeMenu) {
          this.updateleftMenuActiveName(meta.activeMenu);
        } else {
          this.updateleftMenuActiveName(originRouteName);
        }
        let matched = this.$route.matched.filter(
          item => item.meta && item.meta.title
        ).slice(1,this.$route.matched.length);
        let first = matched[0]; //第一个路由
        if (!this.isHome(first)) {
        //   matched = [
        //     { path: "/home", name: "home", meta: { title: "首页" } }
        //   ].concat(matched);
        }
        var levelList = matched.filter(item => item.meta && item.meta.title);

        this.updateBreadcrumb(levelList); //面包屑
        //tab
        let tab = {
          title: meta.title, //中文名
          routeName: originRouteName, //路由名称
          params: routeParams,
          noCache: meta.noCache
        };
        let index1 = this.keepPageTabs.findIndex(
          b => b.routeName === currentRouteName
        );
        // 当前页面不在tab中
        if (index1 === -1 && currentRouteName) {
          this.updateKeepPageTabs({ type: "add", data: tab });
        }
      }
    }
  },
  //方法集合
  methods: {
    ...mapMutations([
      "updateLeftMenu",
      "updateleftMenuActiveName",
      "updateKeepPageTabs",
      "updateBreadcrumb"
    ]),
    isHome(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim() === "home";
    },
    getMenu() {
      var menuList = [
        {
          name: "首页",
          routeName: "Dashboard",
          isindex: true,
            icon:'el-icon-s-home',
            twoMenu: []
        },
        // {
        //   name: "关于",
        //   routeName: "about",
        //   isindex: true,
        //   twoMenu: []
        // },
        {
          name: "资源管理",
          routeName: "resourceManage",
          isindex: true,
          icon:'el-icon-folder-opened',
          twoMenu: [
            {
              name: "考试内容",
              routeName: "subjects"
            },
              {
              name: "人员管理",
              routeName: "teachers"
            },
              {
              name: "设备管理",
              routeName: "devices"
            },
              {
              name: "场所管理",
              routeName: "rooms"
            },
              {
              name: "考站管理",
              routeName: "stations"
            },
          ]
        },
        {
          name: "考试管理",
          routeName: "examManage",
          isindex: true,
            icon:'el-icon-document-checked',
            twoMenu: [
            {
              name: "考试安排",
              routeName: "examArrange"
            },
            {
              name: "考生查询",
              routeName: "students"
            },
            {
              name: "成绩查询",
              routeName: "examResults"
            },
            {
              name: "资讯&通知",
              routeName: "notice"
            },
              {
                  name: "缺考统计",
                  routeName: "examMiss",
              },
          ]
        },
        {
          name: "统计分析",
          routeName: "statisticsManage",
          isindex: true,
            icon:'el-icon-picture-outline-round',
            twoMenu: [
            {
              name: "项目成绩统计",
              routeName: "subjectScores"
            },

            {
              name: "考生成绩统计",
              routeName: "studentScores"
            },
            {
              name: "项目成绩分析",
              routeName: "subjectAnalysis"
            },
            {
              name: "考生成绩分析",
              routeName: "studentAnalysis"
            },
              {
                  name: "教学成绩分析",
                  routeName: "teacherAnalysis",
              },
              {
                  name: "考生总成绩统计",
                  routeName: "totalScores",
              },
          ]
        },
        // {
        //   name: "系统管理",
        //   routeName: "sysManage",
        //   isindex: true,
        //   twoMenu: [
        //     {
        //       name: "用户管理",
        //       routeName: "userManage"
        //     },
        //
        //     {
        //       name: "权限管理",
        //       routeName: "permissionManage"
        //     },
        //     {
        //       name: "系统设置",
        //       routeName: "sysSetting"
        //     },
        //   ]
        // },
        {
          name: "理论考试",
          routeName: "theoryManage",
          isindex: true,
            icon:'el-icon-edit-outline',
            twoMenu: [
            {
              name: "考试管理",
              routeName: "theoryList"
            },

            {
              name: "试卷管理",
              routeName: "examPaper"
            },
            {
              name: "成绩管理",
              routeName: "theoryScore"
            },
            {
              name: "在线批卷",
              routeName: "theoryCheck"
            },
            {
              name: "题库管理",
              routeName: "theoryQuestions"
            },
          ]
        },
      ];
      // this.$store.commit("updateLeftMenu", menuList);
      this.updateLeftMenu(menuList);
    }
  }
};
</script>
<style lang='less'>
//@import url(); 引入公共css类



</style>



// WEBPACK FOOTER //
// src/page/index.vue